import * as yup from 'yup';

import { notRequiredEmailSchema, notRequiredPhoneSchema } from '~constants/regexConst';
import { Account } from '~hooks/useAccount/models';

const contactSchema = yup.object().shape({
  name: yup.string().notRequired(),
  email: notRequiredEmailSchema,
  phone: notRequiredPhoneSchema,
});

export const accountContactSchema = yup.object().shape({
  primaryContact: contactSchema.notRequired(),
  isBillingContactSame: yup.boolean().required(),
  billingContact: contactSchema.notRequired(),
});
export type AccountContactDto = yup.InferType<typeof accountContactSchema>;

export function setAccountContactSchemaDefaultValues(account?: Account) {
  const defaultValues: AccountContactDto = {
    primaryContact: {
      name: account?.primaryContact?.name ?? '',
      email: account?.primaryContact?.email ?? '',
      phone: account?.primaryContact?.phone ?? '',
    },
    isBillingContactSame: account?.isBillingContactSame ?? true,
    billingContact: {
      name: account?.billingContact?.name ?? '',
      email: account?.billingContact?.email ?? '',
      phone: account?.billingContact?.phone ?? '',
    },
  };

  return defaultValues;
}
